import type { Game } from '../lib/api';

export type FilterState = {
  game_id: string;
  section_types: string[];
  section: string;
  min_price: string;
  max_price: string;
  min_qty: string;
  sort: 'price_asc' | 'price_desc' | 'section';
};

const SECTION_TYPES = [
  'Coaches Club',
  'Mezz Club A',
  'Mezz Club B',
  'Mezz Club B1',
  'Mezz Club C',
  'Field 1 Center',
  'Field 1',
  'Field 2',
  'Field 3 Front',
  'Field 3 Back',
  'Mezzanine Front',
  'Mezzanine Back',
  'Loge',
  'Terrace Center',
  'Terrace Corner',
  'Terrace End Zone',
];

export default function ListingFilters({
  games,
  value,
  onChange,
}: {
  games: Game[];
  value: FilterState;
  onChange: (f: FilterState) => void;
}) {
  return (
    <div className="card" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '0.75rem' }}>
      <label>
        <span>Game</span>
        <select value={value.game_id} onChange={(e) => onChange({ ...value, game_id: e.target.value })}>
          <option value="">All upcoming</option>
          {games.map((g) => (
            <option key={g.game_id} value={g.game_id}>
              {g.opponent} — {g.game_date}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span>Section type</span>
        <select
          multiple
          value={value.section_types}
          onChange={(e) =>
            onChange({
              ...value,
              section_types: Array.from(e.target.selectedOptions).map((o) => o.value),
            })
          }
          size={4}
        >
          {SECTION_TYPES.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </label>
      <label>
        <span>Section #</span>
        <input value={value.section} onChange={(e) => onChange({ ...value, section: e.target.value })} />
      </label>
      <label>
        <span>Min $/seat</span>
        <input
          type="number"
          value={value.min_price}
          onChange={(e) => onChange({ ...value, min_price: e.target.value })}
        />
      </label>
      <label>
        <span>Max $/seat</span>
        <input
          type="number"
          value={value.max_price}
          onChange={(e) => onChange({ ...value, max_price: e.target.value })}
        />
      </label>
      <label>
        <span>Quantity</span>
        <select value={value.min_qty} onChange={(e) => onChange({ ...value, min_qty: e.target.value })}>
          <option value="">Any</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4+</option>
        </select>
      </label>
      <label>
        <span>Sort</span>
        <select
          value={value.sort}
          onChange={(e) => onChange({ ...value, sort: e.target.value as FilterState['sort'] })}
        >
          <option value="price_asc">Price ↑</option>
          <option value="price_desc">Price ↓</option>
          <option value="section">Section</option>
        </select>
      </label>
    </div>
  );
}
